import {FormSectionType} from "../../@types/forTestingFormSectionsResources.ts";
import {handleNumericField, handlePhonePrefix, removeSpaces} from "../../helpers/register-form/registerFormHelper.tsx";

export const AcceptPaymentsPageFormSectionsIndividualConfig: FormSectionType[] = [
    {
        rows: [
            {
                inputs: [
                    {
                        label: 'name',
                        registerLabel: 'individual_merchant_name',
                        required: false,
                        type: 'text',
                        singleInput: true,
                        onchange: () => {},
                    },
                    {
                        label: 'surname',
                        registerLabel: 'individual_merchant_surname',
                        required: false,
                        type: 'text',
                        singleInput: true,
                        onchange: () => {},
                    }
                ]
            },
            {
                inputs: [
                    {
                        label: 'merchant_personal_code',
                        registerLabel: 'individual_merchant_code',
                        required: false,
                        type: 'text',
                        singleInput: true,
                        onchange: (e) => handleNumericField(e),
                    },
                    {
                        label: 'merchant_individual_activity_certificate_number',
                        registerLabel: 'merchant_individual_activity_certificate_number',
                        required: false,
                        type: 'text',
                        singleInput: true,
                        onchange: (e) => removeSpaces(e),
                    }
                ]
            },
            {
                inputs: [
                    {
                        label: 'merchant_address',
                        registerLabel: 'individual_merchant_address',
                        required: false,
                        type: 'text',
                        hint: 'merchant_address_hint',
                        singleInput: true,
                        onchange: () => {},
                    },
                    {
                        label: 'contact_email',
                        registerLabel: 'individual_merchant_email',
                        required: false,
                        type: 'email',
                        hint: 'merchant_email_hint_individual',
                        singleInput: true,
                        onchange: () => {},
                    }
                ]
            },
            {
                inputs: [
                    {
                        label: 'contact_phone_number',
                        registerLabel: 'individual_merchant_phone_number_prefix',
                        required: false,
                        type: 'tel',
                        initialValue: '+370',
                        pattern: '.{2,}',
                        maxLength: 4,
                        secondInput: {
                            registerLabel: 'individual_merchant_phone_number',
                            required: false,
                            type: 'tel',
                            maxLength: 16,
                            onchange: (e) => handleNumericField(e),
                        },
                        hint: 'merchant_phone_number_hint',
                        onchange: (e) => handlePhonePrefix(e)
                    },
                    {
                        label: 'bank_account_number',
                        registerLabel: 'individual_agreement_bank_account',
                        required: false,
                        type: 'text',
                        hint: 'bank_account_number_hint',
                        singleInput: true,
                        onchange: (e) => removeSpaces(e),
                    }
                ]
            }
        ]
    }
]
